import { render, staticRenderFns } from "./footerMobile.vue?vue&type=template&id=1181b432&scoped=true"
import script from "./footerMobile.vue?vue&type=script&lang=js"
export * from "./footerMobile.vue?vue&type=script&lang=js"
import style0 from "./footerMobile.vue?vue&type=style&index=0&id=1181b432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1181b432",
  null
  
)

export default component.exports